import { useMemo } from 'react'
import { buildOrderUrl } from '~/utils/urls'

interface UseLoginPageUrlParams {
  /**
   * ログイン後にリダイレクトするページ
   */
  redirectTo?: URL | string
}

/**
 * ログインページのURLを返す、だけ
 */
export function useLoginPageUrl({
  redirectTo
}: UseLoginPageUrlParams = {}): URL {
  return useMemo(() => {
    const url = buildOrderUrl('signin')

    if (redirectTo) {
      url.searchParams.set('r', redirectTo.toString())
    }

    return url
  }, [redirectTo])
}
